const tipo = [
  //Array de Opções usadas no SELECT de atualizar cadastro e cadastrar proprietario
  { id: 1, label: "Lead", value: "LEAD" },
  { id: 2, label: "Revendedor", value: "REVENDEDOR" },
  { id: 3, label: "Proprietario", value: "PROPRIETARIO" },
  { id: 4, label: "Golpista", value: "GOLPISTA" },
];
export const tipoOptions: any[] = tipo.map((tipo) => ({
  // Map do array
  id: tipo.id,
  label: tipo.label,
  value: tipo.value,
}));
